module.exports = __webpack_public_path__ + "img/opened.dbc853b4.webp";